const EXCLUDED_FP_HOSTS = new Set(['support.cian.ru']);

const isCianRuHost = (hostname: string): boolean => {
  return hostname === 'cian.ru' || hostname.endsWith('.cian.ru');
};

export const isFpUrl = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);

    if (EXCLUDED_FP_HOSTS.has(hostname)) {
      return false;
    }

    return isCianRuHost(hostname);
  } catch {
    return false;
  }
};
